/** Phân quyền — sản phẩm */
export const PRODUCT_PERMISSION_CODES = {
  WEB_BH_PRODUCT_LIST: 'WEB_BH_PRODUCT_LIST',
  WEB_BH_PRODUCT_ADD: 'WEB_BH_PRODUCT_ADD',
  WEB_BH_PRODUCT_EDIT: 'WEB_BH_PRODUCT_EDIT',
  WEB_BH_PRODUCT_DELETE: 'WEB_BH_PRODUCT_DELETE',
  WEB_BH_PRODUCT_IMPORT: 'WEB_BH_PRODUCT_IMPORT',
  /** Import ảnh sản phẩm (Excel dọc / ngang). */
  WEB_BH_PRODUCT_IMPORT_IMAGE: 'WEB_BH_PRODUCT_IMPORT_IMAGE',
  WEB_BH_PRODUCT_EXPORT: 'WEB_BH_PRODUCT_EXPORT',
  /**
   * Xem giá vốn / lợi nhuận / giá trị tồn kho và mọi UI liên quan.
   * Không có quyền → ẩn cột/field/báo cáo liên quan giá vốn–lợi nhuận.
   */
  WEB_BH_XEM_GIA_VON_LOI_NHUAN: 'WEB_BH_XEM_GIA_VON_LOI_NHUAN',
} as const

export type ProductPermissionCode =
  (typeof PRODUCT_PERMISSION_CODES)[keyof typeof PRODUCT_PERMISSION_CODES]

export const productPermissionCodeValues = Object.values(PRODUCT_PERMISSION_CODES)

export const PRODUCT_READ_PERMISSIONS = [
  PRODUCT_PERMISSION_CODES.WEB_BH_PRODUCT_LIST,
] as const

export const PRODUCT_MUTATE_PERMISSIONS = [
  PRODUCT_PERMISSION_CODES.WEB_BH_PRODUCT_ADD,
  PRODUCT_PERMISSION_CODES.WEB_BH_PRODUCT_EDIT,
  PRODUCT_PERMISSION_CODES.WEB_BH_PRODUCT_DELETE,
] as const

/** Field keys cần ẩn khi không có WEB_BH_XEM_GIA_VON_LOI_NHUAN. */
export const GIA_VON_LOI_NHUAN_FIELD_KEYS = [
  'giaVon',
  'giaTriTonKho',
  'loiNhuan',
  'giaTri',
  'giaTriNhap',
  'giaTriThuan',
  'giaTriTra',
] as const

/** Concern báo cáo liên quan giá vốn / lợi nhuận (MG_* / LN_THANG: báo cáo margin của doanh thu – LN). */
export const GIA_VON_LOI_NHUAN_CONCERNS = ['LOI_NHUAN', 'GIA_TRI_KHO', 'MG_KHACH', 'MG_NHOM', 'LN_THANG'] as const
